import React from 'react';

const InfoCard = ({ style, title, subtitle, children }) => {
  return (
    <div style={{
      background: 'rgba(99, 102, 241, 0.1)',
      padding: '2rem',
      marginBottom: '2rem',
      borderRadius: '1rem',
      flex: '1',
      maxWidth: 'calc(560px - 2rem)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1px solid rgba(99, 102, 241, 0.2)',
      ...style
    }}>
      <h2 className='subtitle'>{title}</h2>

      <div style={{
        color: '#ffffff',
        marginBottom: '1.5rem',
      }}>
        <h1 className='title'>
          {subtitle}
        </h1>

        {children}
      </div>
    </div>
  );
};

export default InfoCard;
